import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { Logo } from '@/components/generals/logo'
import { SAMPLE_TRIP_CODE } from '@/constants/trip'

const FOOTER_LINKS = [
    { href: '/trips/new', label: 'Start a trip' },
    { href: `/trips/${SAMPLE_TRIP_CODE}`, label: 'Sample trip' },
    { href: '/#how-it-works', label: 'How it works' },
    { href: '/#features', label: 'Features' },
    { href: '/#faq', label: 'FAQ' }
]

export const SiteFooter: FC = (): ReactNode => {
    return (
        <footer id='site-footer' className='border-t border-border bg-card/60'>
            <div className='mx-auto flex max-w-6xl flex-col gap-8 px-4 py-10 sm:px-6 md:flex-row md:items-start md:justify-between'>
                <div className='max-w-sm'>
                    <Logo />

                    <p className='mt-3 text-sm leading-relaxed text-muted-foreground'>
                        The shared tab for group trips. Log costs as you go, see who owes whom, and settle up before the flight home.
                    </p>
                </div>

                <nav aria-label='Footer'>
                    <ul className='grid grid-cols-2 gap-x-10 gap-y-2.5 sm:grid-cols-3'>
                        {FOOTER_LINKS.map(link => (
                            <li key={link.href}>
                                <Link href={link.href} className='text-sm font-semibold text-foreground/70 hover:text-foreground'>
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>

            <div className='border-t border-border/70'>
                <p className='mx-auto max-w-6xl px-4 py-5 text-xs text-muted-foreground sm:px-6'>
                    Tallyho is free to use. Trips are private to anyone holding their link.
                </p>
            </div>
        </footer>
    )
}
